export class BannedTokenIdsRequest {
    spaceId;
    constructor(spaceId) {
        this.spaceId = spaceId;
    }
    toKey() {
        return `bannedTokenIds:${this.spaceId}`;
    }
}
export class OwnerOfTokenRequest {
    spaceId;
    tokenId;
    constructor(spaceId, tokenId) {
        this.spaceId = spaceId;
        this.tokenId = tokenId;
    }
    toKey() {
        return `ownerOfToken:${this.spaceId}:${this.tokenId.toString()}`;
    }
}
export class IsTokenBanned {
    spaceId;
    tokenId;
    constructor(spaceId, tokenId) {
        this.spaceId = spaceId;
        this.tokenId = tokenId;
    }
    toKey() {
        return `isBanned:${this.spaceId}:${this.tokenId.toString()}`;
    }
}
export class EntitlementRequest {
    spaceId;
    channelId;
    userId;
    permission;
    constructor(spaceId, channelId, userId, permission) {
        this.spaceId = spaceId;
        this.channelId = channelId;
        this.userId = userId;
        this.permission = permission;
    }
    toKey() {
        return `{spaceId:${this.spaceId},channelId:${this.channelId},userId:${this.userId},permission:${this.permission}}`;
    }
}
//# sourceMappingURL=Keyable.js.map